import request from '../utils/request';
import { buildApiPayload } from '../utils/api';
import baseApi from './baseApi';

export function getCateringOrders(params, signal) {
  return request({
    url: '/catering-orders',
    method: 'get',
    data: params,
    signal,
  });
}

export function createCateringOrder(params) {
  return request({
    url: '/catering-orders',
    method: 'post',
    data: params,
  });
}

export function updateCateringOrder(uuid, params) {
  return request({
    url: `/catering-orders/${uuid}`,
    method: 'put',
    data: params,
  });
}

export function deleteCateringOrder(uuid) {
  return request({
    url: `/catering-orders/${uuid}`,
    method: 'delete',
  });
}

export function finalizeCateringOrder(uuid, params) {
  return request({
    url: `/catering-orders/${uuid}/finalize`,
    method: 'put',
    data: params,
  });
}

export function getRecurringOrders(params, signal) {
  return request({
    url: '/recurring-orders',
    method: 'get',
    data: params,
    signal,
  });
}

export function createRecurringOrder(params) {
  return request({
    url: '/recurring-orders',
    method: 'post',
    data: params,
  });
}

export function updateRecurringOrder(uuid, params) {
  return request({
    url: `/recurring-orders/${uuid}`,
    method: 'put',
    data: params,
  });
}

export function deleteRecurringOrder(uuid) {
  return request({
    url: `/recurring-orders/${uuid}`,
    method: 'delete',
  });
}

// Timers API

export function getCateringTimers(params, signal) {
  return request({
    url: '/cateringTimerCycleHistory',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getCateringTimersTotal(params, signal) {
  return request({
    url: '/cateringTimerCycleHistory/total',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getExelExport(params) {
  return request({
    url: '/cateringTimerCycleHistory/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}

export function deleteCateringTimer(uuid) {
  return request({
    url: `/cateringTimerCycleHistory/${uuid}`,
    method: 'delete',
  });
}

const cateringApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    bulkDeleteCateringTCHs: builder.mutation({
      query: ({ uuids }) => ({
        url: '/cateringTimerCycleHistory',
        method: 'DELETE',
        data: {
          uuids,
        },
      }),
    }),
  }),
});

export const {
  useBulkDeleteCateringTCHsMutation: useBulkDeleteCateringTCHs,
} = cateringApi;

export default cateringApi;
